export const QA_NAME_GRETA_AI_CHAT_MESSAGE_ACTIONS = 'gretaAIChatMessageActions'

export const QA_NAME_GRETA_AI_CHAT_MESSAGE_COPY = 'gretaAIChatMessageCopy'

export const QA_NAME_GRETA_AI_CHAT_MESSAGE_FEEDBACK_DOWN =
  'gretaAIChatMessageFeedbackDown'

export const QA_NAME_GRETA_AI_CHAT_MESSAGE_FEEDBACK_UP =
  'gretaAIChatMessageFeedbackUp'

export const QA_NAME_GRETA_AI_CHAT_MESSAGE_RETRY = 'gretaAIChatMessageRetry'
